import { TConfigurationFormModelTypes } from 'src/app/core/models/form-builder-types-configurations.model';
import { fieldsBaseConfigurationFormModel } from '../shared.configuration';
import { BaseFormlyFieldConfiguration } from './base-formly-field-configuration';
import {
  getOtpDataFetchInputFieldSettingsConfig,
  otpDataFetchFieldParseIntoSettingsFormModel,
  otpDataFetchFieldUpdateFromSettingsFormModel,
} from '../custom-otp-data-fetch-field-type.configuration';
import {
  getDefaultBaseSettingsConfigFormly,
  getPopulateRelativeToRootFieldConfig,
  getPopulatesPropsSettingsConfigFormly,
} from '../../form-fields-formly-settings/form-builder-default-settings-configuration-formly-fields.utils';
import { Injector } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';

export class CustomOtpDataFetchFormlyFieldConfiguration extends BaseFormlyFieldConfiguration {
  constructor(injector: Injector, field: FormlyFieldConfig) {
    super(injector, field);
    this.settingsFormlyModel = {
      ...fieldsBaseConfigurationFormModel(),
      url: '',
      useBaseUrl: true,
      endpointCode: '',
      otpLength: 0,
      populates: [],
      payloadKey: '',
      allowOtpNumbersOnly: false,
      inputRegexValueValidation: '',
      inputRegexValueValidationMessage: '',
      messagePendingRequestOtp: '',
      messageOtpRequired: '',
      messageOtpVerificationPending: '',
      messageDataFetchPending: '',
      messageDataFetchComplete: '',
    };
    this.settingsFormlyForm = [
      ...getOtpDataFetchInputFieldSettingsConfig(this.formBuilderService),
      ...getDefaultBaseSettingsConfigFormly(this.formBuilderService),
      {
        key: 'defaultValue',
        type: 'input',
        props: {
          label: 'Default value',
          placeholder: 'Enter default value',
        },
        validation: {
          messages: {
            maxLength: 'Default value is longer than Input Length value',
          },
        },
        expressions: {
          'props.maxLength': field => {
            return (
              field.parent?.model?.genericDataFetchFieldContentConfig
                ?.genericInputLength ?? null
            );
          },
        },
      },
      getPopulateRelativeToRootFieldConfig(),
      ...getPopulatesPropsSettingsConfigFormly(this.formBuilderService, []),
    ];
  }

  override parseFieldConfigIntoSettingsFormModel(): TConfigurationFormModelTypes {
    return otpDataFetchFieldParseIntoSettingsFormModel(this.field);
  }

  override updateFieldConfigFromSettingsFormModel(model: any) {
    return otpDataFetchFieldUpdateFromSettingsFormModel(this.field, model);
  }
}
